import React from 'react';

const Header = () => {
  return (
    <center>
      <p style={{ fontWeight: 'bold', fontSize: '18px' }}>WEBSITE CEK KUOTA XL & AXIS</p>
      <b>By : BAGAS RAMANDANI</b><br />
      <span className="version-badge">v4.0.0</span>
    </center>
  );
};

export default Header;
